// extracted by mini-css-extract-plugin
module.exports = {"container":"MillWeightFooter_container__2hIAG"};